// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const AddParticipantSchedule = __t.object("AddParticipantSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  sessionId: __t.u64(),
  participantIdentity: __t.identity(),
  get role() {
    return __t.option(SessionRole);
  },
});
export type AddParticipantSchedule = __Infer<typeof AddParticipantSchedule>;

export const AgentIdentityService = __t.object("AgentIdentityService", {
  identity: __t.identity(),
  serviceName: __t.string(),
  seenAt: __t.timestamp(),
});
export type AgentIdentityService = __Infer<typeof AgentIdentityService>;

// The tagged union or sum type for the algebraic type `AppRole`.
export const AppRole = __t.enum("AppRole", {
  Member: __t.unit(),
  Admin: __t.unit(),
  OrgAdmin: __t.unit(),
  OrgViewer: __t.unit(),
  Contractor: __t.unit(),
  OrientationAdmin: __t.unit(),
});
export type AppRole = __Infer<typeof AppRole>;

export const AssignOrientationSchedule = __t.object("AssignOrientationSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  assignmentId: __t.u64(),
  projectId: __t.string(),
  agentIdentity: __t.identity(),
  orientationId: __t.string(),
  assignerIdentity: __t.identity(),
  attempt: __t.u32(),
});
export type AssignOrientationSchedule = __Infer<typeof AssignOrientationSchedule>;

export const Assignment = __t.object("Assignment", {
  assignmentId: __t.u64(),
  email: __t.string(),
  userId: __t.option(__t.string()),
  orientationId: __t.string(),
  projectId: __t.string(),
  get orientationVersion() {
    return OrientationVersion;
  },
  get status() {
    return AssignmentStatus;
  },
  assignedAt: __t.timestamp(),
  startedAt: __t.option(__t.timestamp()),
  completedAt: __t.option(__t.timestamp()),
  cancelledAt: __t.option(__t.timestamp()),
  cohortAssignmentId: __t.option(__t.u64()),
  cohortAdopted: __t.bool(),
});
export type Assignment = __Infer<typeof Assignment>;

export const AssignmentAttempt = __t.object("AssignmentAttempt", {
  attemptId: __t.u64(),
  assignmentId: __t.u64(),
  attemptNumber: __t.u32(),
  sessionId: __t.u64(),
  get status() {
    return AttemptStatus;
  },
  startedAt: __t.option(__t.timestamp()),
  endedAt: __t.option(__t.timestamp()),
  scorePct: __t.option(__t.u32()),
  passed: __t.option(__t.bool()),
});
export type AssignmentAttempt = __Infer<typeof AssignmentAttempt>;

export const AssignmentProgress = __t.object("AssignmentProgress", {
  assignmentId: __t.u64(),
  currentStepId: __t.option(__t.string()),
  currentPosition: __t.u32(),
  enteredCurrentStepAt: __t.option(__t.timestamp()),
  sessionId: __t.u64(),
  updatedAt: __t.timestamp(),
  currentBeat: __t.u32(),
  totalBeats: __t.u32(),
  pendingChecks: __t.u32(),
  atNextStop: __t.bool(),
  ready: __t.bool(),
});
export type AssignmentProgress = __Infer<typeof AssignmentProgress>;

// The tagged union or sum type for the algebraic type `AssignmentStatus`.
export const AssignmentStatus = __t.enum("AssignmentStatus", {
  NotStarted: __t.unit(),
  InProgress: __t.unit(),
  Completed: __t.unit(),
  Cancelled: __t.unit(),
});
export type AssignmentStatus = __Infer<typeof AssignmentStatus>;

export const AssignmentStepMetric = __t.object("AssignmentStepMetric", {
  id: __t.u64(),
  assignmentId: __t.u64(),
  stepId: __t.string(),
  attemptNumber: __t.u32(),
  enteredAt: __t.timestamp(),
  exitedAt: __t.option(__t.timestamp()),
  timeSpentSeconds: __t.option(__t.u32()),
});
export type AssignmentStepMetric = __Infer<typeof AssignmentStepMetric>;

// The tagged union or sum type for the algebraic type `AttemptStatus`.
export const AttemptStatus = __t.enum("AttemptStatus", {
  InProgress: __t.unit(),
  Completed: __t.unit(),
  SentBack: __t.unit(),
  Abandoned: __t.unit(),
});
export type AttemptStatus = __Infer<typeof AttemptStatus>;

export const CheckAnswer = __t.object("CheckAnswer", {
  id: __t.u64(),
  assignmentId: __t.u64(),
  attemptNumber: __t.u32(),
  checkId: __t.string(),
  stepId: __t.string(),
  tryNumber: __t.u32(),
  selectedOptionIds: __t.array(__t.string()),
  correct: __t.bool(),
  expired: __t.bool(),
  sessionId: __t.u64(),
  identity: __t.identity(),
  answeredAt: __t.timestamp(),
});
export type CheckAnswer = __Infer<typeof CheckAnswer>;

export const CheckEntry = __t.object("CheckEntry", {
  checkId: __t.string(),
  beat: __t.u32(),
  get checkType() {
    return CheckType;
  },
  question: __t.string(),
  get options() {
    return __t.array(CheckOption);
  },
  correctOptionIds: __t.array(__t.string()),
  multiSelect: __t.bool(),
  shuffleOptions: __t.bool(),
  retryLimit: __t.option(__t.u32()),
  timeLimitSeconds: __t.option(__t.u32()),
  showCorrectAnswer: __t.bool(),
  get grading() {
    return CheckGrading;
  },
});
export type CheckEntry = __Infer<typeof CheckEntry>;

// The tagged union or sum type for the algebraic type `CheckGrading`.
export const CheckGrading = __t.enum("CheckGrading", {
  All: __t.unit(),
  Any: __t.unit(),
});
export type CheckGrading = __Infer<typeof CheckGrading>;

export const CheckOption = __t.object("CheckOption", {
  id: __t.string(),
  text: __t.string(),
});
export type CheckOption = __Infer<typeof CheckOption>;

// The tagged union or sum type for the algebraic type `CheckType`.
export const CheckType = __t.enum("CheckType", {
  MultipleChoice: __t.unit(),
  OpenEnded: __t.unit(),
  WorldSelection: __t.unit(),
  WorldLocation: __t.unit(),
});
export type CheckType = __Infer<typeof CheckType>;

export const CloseSessionSchedule = __t.object("CloseSessionSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  sessionId: __t.u64(),
});
export type CloseSessionSchedule = __Infer<typeof CloseSessionSchedule>;

export const Cohort = __t.object("Cohort", {
  cohortId: __t.u64(),
  name: __t.string(),
  projectId: __t.string(),
  createdByEmail: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  archivedAt: __t.option(__t.timestamp()),
});
export type Cohort = __Infer<typeof Cohort>;

export const CohortAssignment = __t.object("CohortAssignment", {
  cohortAssignmentId: __t.u64(),
  cohortId: __t.u64(),
  orientationId: __t.string(),
  get orientationVersion() {
    return OrientationVersion;
  },
  get status() {
    return CohortAssignmentStatus;
  },
  assignedByEmail: __t.string(),
  assignedAt: __t.timestamp(),
  cancelledAt: __t.option(__t.timestamp()),
  cancelledBy: __t.option(__t.string()),
});
export type CohortAssignment = __Infer<typeof CohortAssignment>;

// The tagged union or sum type for the algebraic type `CohortAssignmentStatus`.
export const CohortAssignmentStatus = __t.enum("CohortAssignmentStatus", {
  Active: __t.unit(),
  Cancelled: __t.unit(),
});
export type CohortAssignmentStatus = __Infer<typeof CohortAssignmentStatus>;

export const CohortMember = __t.object("CohortMember", {
  memberId: __t.u64(),
  cohortId: __t.u64(),
  email: __t.string(),
});
export type CohortMember = __Infer<typeof CohortMember>;

export const CommandLocation = __t.object("CommandLocation", {
  latitude: __t.f64(),
  longitude: __t.f64(),
  altitude: __t.option(__t.f64()),
});
export type CommandLocation = __Infer<typeof CommandLocation>;

export const CommandSpec = __t.object("CommandSpec", {
  get commandType() {
    return CommandType;
  },
  twinIds: __t.array(__t.string()),
  propertyNames: __t.array(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  altitude: __t.option(__t.f64()),
  durationMs: __t.option(__t.u32()),
  get flyTarget() {
    return __t.option(CommandTarget);
  },
  get lookAtTarget() {
    return __t.option(CommandTarget);
  },
  lookAtBlendStart: __t.option(__t.f32()),
  distance: __t.option(__t.f32()),
  pitch: __t.option(__t.f32()),
  rotateSpeed: __t.option(__t.f32()),
  opacity: __t.option(__t.f32()),
  message: __t.option(__t.string()),
  get path() {
    return __t.array(CommandLocation);
  },
  telemetryNames: __t.array(__t.string()),
});
export type CommandSpec = __Infer<typeof CommandSpec>;

// The tagged union or sum type for the algebraic type `CommandTarget`.
export const CommandTarget = __t.enum("CommandTarget", {
  Twin: __t.string(),
  get Location() {
    return CommandLocation;
  },
});
export type CommandTarget = __Infer<typeof CommandTarget>;

// The tagged union or sum type for the algebraic type `CommandType`.
export const CommandType = __t.enum("CommandType", {
  HighlightTwin: __t.unit(),
  HighlightGeo: __t.unit(),
  FlyToTwin: __t.unit(),
  FlyToLocation: __t.unit(),
  LookAtTwin: __t.unit(),
  LookAtLocation: __t.unit(),
  FlyAndLookAt: __t.unit(),
  OrbitTwin: __t.unit(),
  FollowTwin: __t.unit(),
  StopCamera: __t.unit(),
  SelectTwins: __t.unit(),
  ClearSelection: __t.unit(),
  SetTransparency: __t.unit(),
  FlyAlongPath: __t.unit(),
  SetCameraMode: __t.unit(),
  ShowRelationships: __t.unit(),
  HideRelationships: __t.unit(),
  ShowTwinInfo: __t.unit(),
});
export type CommandType = __Infer<typeof CommandType>;

export const ConnectedClient = __t.object("ConnectedClient", {
  connectionId: __t.connectionId(),
  identity: __t.identity(),
  email: __t.string(),
  connectedAt: __t.timestamp(),
  sessionId: __t.option(__t.u64()),
});
export type ConnectedClient = __Infer<typeof ConnectedClient>;

// The tagged union or sum type for the algebraic type `ExportKind`.
export const ExportKind = __t.enum("ExportKind", {
  Orientations: __t.unit(),
});
export type ExportKind = __Infer<typeof ExportKind>;

export const ExportResultEvent = __t.object("ExportResultEvent", {
  requestId: __t.u128(),
  requestedBy: __t.identity(),
  get kind() {
    return ExportKind;
  },
  success: __t.bool(),
  payload: __t.string(),
  error: __t.option(__t.string()),
  createdAt: __t.timestamp(),
});
export type ExportResultEvent = __Infer<typeof ExportResultEvent>;

export const GeoLocation = __t.object("GeoLocation", {
  latitude: __t.f64(),
  longitude: __t.f64(),
  elevation: __t.f64(),
});
export type GeoLocation = __Infer<typeof GeoLocation>;

export const GroupAutoAdvanceTimer = __t.object("GroupAutoAdvanceTimer", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  groupRunId: __t.u64(),
  stepId: __t.string(),
  firesAt: __t.timestamp(),
});
export type GroupAutoAdvanceTimer = __Infer<typeof GroupAutoAdvanceTimer>;

export const GroupLayout = __t.object("GroupLayout", {
  name: __t.string(),
  memberEmails: __t.array(__t.string()),
  leaderEmail: __t.string(),
  get mode() {
    return GroupRunMode;
  },
  allowLateJoin: __t.bool(),
  autoStallSeconds: __t.u32(),
});
export type GroupLayout = __Infer<typeof GroupLayout>;

export const GroupRun = __t.object("GroupRun", {
  groupRunId: __t.u64(),
  cohortAssignmentId: __t.u64(),
  projectId: __t.string(),
  name: __t.string(),
  sessionId: __t.u64(),
  leaderEmail: __t.string(),
  get mode() {
    return GroupRunMode;
  },
  get status() {
    return GroupRunStatus;
  },
  currentStepId: __t.option(__t.string()),
  currentPosition: __t.u32(),
  pausedByEmail: __t.option(__t.string()),
  createdByEmail: __t.string(),
  createdAt: __t.timestamp(),
  startedAt: __t.option(__t.timestamp()),
  endedAt: __t.option(__t.timestamp()),
  allowLateJoin: __t.bool(),
  autoStallSeconds: __t.u32(),
  stallFiresAt: __t.option(__t.timestamp()),
});
export type GroupRun = __Infer<typeof GroupRun>;

export const GroupRunDetails = __t.object("GroupRunDetails", {
  groupRunId: __t.u64(),
  orientationId: __t.string(),
  orientationName: __t.string(),
  cohortName: __t.string(),
});
export type GroupRunDetails = __Infer<typeof GroupRunDetails>;

export const GroupRunLeader = __t.object("GroupRunLeader", {
  groupRunId: __t.u64(),
  leaderEmail: __t.string(),
  leaderStdbIdentity: __t.string(),
});
export type GroupRunLeader = __Infer<typeof GroupRunLeader>;

// The tagged union or sum type for the algebraic type `GroupRunMode`.
export const GroupRunMode = __t.enum("GroupRunMode", {
  Managed: __t.unit(),
  Auto: __t.unit(),
});
export type GroupRunMode = __Infer<typeof GroupRunMode>;

export const GroupRunParticipant = __t.object("GroupRunParticipant", {
  assignmentId: __t.u64(),
  groupRunId: __t.u64(),
  email: __t.string(),
  displayName: __t.string(),
  connected: __t.bool(),
  pendingChecks: __t.u32(),
  currentBeat: __t.u32(),
  totalBeats: __t.u32(),
  stdbIdentity: __t.string(),
  completed: __t.bool(),
  passed: __t.option(__t.bool()),
  scorePct: __t.option(__t.u32()),
  arrived: __t.bool(),
  ready: __t.bool(),
});
export type GroupRunParticipant = __Infer<typeof GroupRunParticipant>;

// The tagged union or sum type for the algebraic type `GroupRunStatus`.
export const GroupRunStatus = __t.enum("GroupRunStatus", {
  Lobby: __t.unit(),
  Running: __t.unit(),
  Paused: __t.unit(),
  Completed: __t.unit(),
  Cancelled: __t.unit(),
});
export type GroupRunStatus = __Infer<typeof GroupRunStatus>;

export const GroupSessionSchedule = __t.object("GroupSessionSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  groupRunId: __t.u64(),
  projectId: __t.string(),
  orientationId: __t.string(),
  memberAssignmentIds: __t.array(__t.u64()),
  participantIdentities: __t.array(__t.identity()),
  attempt: __t.u32(),
});
export type GroupSessionSchedule = __Infer<typeof GroupSessionSchedule>;

export const MpServiceConfig = __t.object("MpServiceConfig", {
  id: __t.u32(),
  apiBaseUrl: __t.string(),
  mpModuleName: __t.string(),
  mpToken: __t.string(),
  configuredAt: __t.timestamp(),
});
export type MpServiceConfig = __Infer<typeof MpServiceConfig>;

export const NarrateSpec = __t.object("NarrateSpec", {
  text: __t.string(),
  audioRef: __t.option(__t.string()),
});
export type NarrateSpec = __Infer<typeof NarrateSpec>;

export const Notification = __t.object("Notification", {
  id: __t.u64(),
  email: __t.string(),
  kind: __t.string(),
  title: __t.string(),
  body: __t.string(),
  createdAt: __t.timestamp(),
  readAt: __t.option(__t.timestamp()),
});
export type Notification = __Infer<typeof Notification>;

export const ObserverJoin = __t.object("ObserverJoin", {
  observerJoinId: __t.u64(),
  observerEmail: __t.string(),
  sessionId: __t.u64(),
  requestedAt: __t.timestamp(),
});
export type ObserverJoin = __Infer<typeof ObserverJoin>;

export const OrgModuleAdminLineage = __t.object("OrgModuleAdminLineage", {
  id: __t.u32(),
  mintedBy: __t.identity(),
});
export type OrgModuleAdminLineage = __Infer<typeof OrgModuleAdminLineage>;

// The tagged union or sum type for the algebraic type `OrgModuleRole`.
export const OrgModuleRole = __t.enum("OrgModuleRole", {
  Reader: __t.unit(),
  Writer: __t.unit(),
});
export type OrgModuleRole = __Infer<typeof OrgModuleRole>;

export const OrgModuleServiceConfig = __t.object("OrgModuleServiceConfig", {
  id: __t.u32(),
  adminIdentity: __t.identity(),
});
export type OrgModuleServiceConfig = __Infer<typeof OrgModuleServiceConfig>;

export const OrgModuleUser = __t.object("OrgModuleUser", {
  identity: __t.identity(),
  get role() {
    return OrgModuleRole;
  },
});
export type OrgModuleUser = __Infer<typeof OrgModuleUser>;

export const Orientation = __t.object("Orientation", {
  orientationId: __t.string(),
  projectId: __t.string(),
  displayName: __t.string(),
  occupationTarget: __t.array(__t.string()),
  description: __t.string(),
  get status() {
    return OrientationStatus;
  },
  autoAssign: __t.bool(),
  get defaultVersion() {
    return OrientationVersion;
  },
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  passingScorePct: __t.option(__t.u32()),
  showAnswersAtEnd: __t.bool(),
  autoReassignOnFail: __t.bool(),
  maxAttempts: __t.option(__t.u32()),
  createdBy: __t.string(),
});
export type Orientation = __Infer<typeof Orientation>;

export const OrientationCheck = __t.object("OrientationCheck", {
  id: __t.u64(),
  checkId: __t.string(),
  stepId: __t.string(),
  projectId: __t.string(),
  beat: __t.u32(),
  get checkType() {
    return CheckType;
  },
  question: __t.string(),
  get options() {
    return __t.array(CheckOption);
  },
  multiSelect: __t.bool(),
  shuffleOptions: __t.bool(),
  retryLimit: __t.option(__t.u32()),
  timeLimitSeconds: __t.option(__t.u32()),
  showCorrectAnswer: __t.bool(),
  sequenceOrder: __t.u32(),
  get grading() {
    return CheckGrading;
  },
});
export type OrientationCheck = __Infer<typeof OrientationCheck>;

export const OrientationCheckKey = __t.object("OrientationCheckKey", {
  id: __t.u64(),
  checkId: __t.string(),
  projectId: __t.string(),
  correctOptionIds: __t.array(__t.string()),
});
export type OrientationCheckKey = __Infer<typeof OrientationCheckKey>;

// The tagged union or sum type for the algebraic type `OrientationStatus`.
export const OrientationStatus = __t.enum("OrientationStatus", {
  Active: __t.unit(),
  Draft: __t.unit(),
  Archived: __t.unit(),
});
export type OrientationStatus = __Infer<typeof OrientationStatus>;

export const OrientationStep = __t.object("OrientationStep", {
  stepId: __t.string(),
  projectId: __t.string(),
  displayName: __t.string(),
  get location() {
    return GeoLocation;
  },
  durationMinutes: __t.u32(),
});
export type OrientationStep = __Infer<typeof OrientationStep>;

export const OrientationStepLink = __t.object("OrientationStepLink", {
  id: __t.u64(),
  orientationId: __t.string(),
  stepId: __t.string(),
  position: __t.u32(),
});
export type OrientationStepLink = __Infer<typeof OrientationStepLink>;

export const OrientationStepScript = __t.object("OrientationStepScript", {
  id: __t.u64(),
  stepId: __t.string(),
  get orientationVersion() {
    return OrientationVersion;
  },
  totalDurationEstimateMs: __t.option(__t.u32()),
  get source() {
    return ScriptSource;
  },
  updatedAt: __t.timestamp(),
  updatedBy: __t.string(),
});
export type OrientationStepScript = __Infer<typeof OrientationStepScript>;

// The tagged union or sum type for the algebraic type `OrientationVersion`.
export const OrientationVersion = __t.enum("OrientationVersion", {
  Min5: __t.unit(),
  Min10: __t.unit(),
  Min20: __t.unit(),
  Min60: __t.unit(),
  Default: __t.unit(),
});
export type OrientationVersion = __Infer<typeof OrientationVersion>;

export const PendingUser = __t.object("PendingUser", {
  id: __t.u64(),
  email: __t.string(),
  projectId: __t.string(),
  occupation: __t.string(),
  createdBy: __t.string(),
  createdAt: __t.timestamp(),
});
export type PendingUser = __Infer<typeof PendingUser>;

export const ProjectAgent = __t.object("ProjectAgent", {
  projectId: __t.string(),
  agentIdentity: __t.identity(),
  displayName: __t.string(),
  updatedAt: __t.timestamp(),
  agentServiceName: __t.option(__t.string()),
});
export type ProjectAgent = __Infer<typeof ProjectAgent>;

export const RepointSessionSchedule = __t.object("RepointSessionSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
  sessionId: __t.u64(),
  projectId: __t.string(),
  old: __t.option(__t.identity()),
  new: __t.option(__t.identity()),
  attempt: __t.u32(),
});
export type RepointSessionSchedule = __Infer<typeof RepointSessionSchedule>;

export const ScriptAction = __t.object("ScriptAction", {
  id: __t.u64(),
  stepId: __t.string(),
  get orientationVersion() {
    return OrientationVersion;
  },
  beat: __t.u32(),
  sequenceOrder: __t.u32(),
  get actionKind() {
    return ScriptActionKind;
  },
  get commandType() {
    return __t.option(CommandType);
  },
  twinIds: __t.array(__t.string()),
  propertyNames: __t.array(__t.string()),
  latitude: __t.option(__t.f64()),
  longitude: __t.option(__t.f64()),
  altitude: __t.option(__t.f64()),
  durationMs: __t.option(__t.u32()),
  get flyTarget() {
    return __t.option(CommandTarget);
  },
  get lookAtTarget() {
    return __t.option(CommandTarget);
  },
  lookAtBlendStart: __t.option(__t.f32()),
  distance: __t.option(__t.f32()),
  pitch: __t.option(__t.f32()),
  rotateSpeed: __t.option(__t.f32()),
  opacity: __t.option(__t.f32()),
  message: __t.option(__t.string()),
  narrateText: __t.option(__t.string()),
  audioRef: __t.option(__t.string()),
  paramsJson: __t.option(__t.string()),
  get path() {
    return __t.option(__t.array(CommandLocation));
  },
  telemetryNames: __t.option(__t.array(__t.string())),
});
export type ScriptAction = __Infer<typeof ScriptAction>;

export const ScriptActionEntry = __t.object("ScriptActionEntry", {
  beat: __t.u32(),
  get action() {
    return ScriptActionInput;
  },
});
export type ScriptActionEntry = __Infer<typeof ScriptActionEntry>;

// The tagged union or sum type for the algebraic type `ScriptActionInput`.
export const ScriptActionInput = __t.enum("ScriptActionInput", {
  get Command() {
    return CommandSpec;
  },
  get Narrate() {
    return NarrateSpec;
  },
  get Wait() {
    return WaitSpec;
  },
});
export type ScriptActionInput = __Infer<typeof ScriptActionInput>;

// The tagged union or sum type for the algebraic type `ScriptActionKind`.
export const ScriptActionKind = __t.enum("ScriptActionKind", {
  Command: __t.unit(),
  Narrate: __t.unit(),
  Wait: __t.unit(),
});
export type ScriptActionKind = __Infer<typeof ScriptActionKind>;

// The tagged union or sum type for the algebraic type `ScriptSource`.
export const ScriptSource = __t.enum("ScriptSource", {
  Authored: __t.unit(),
  DatabricksGenerated: __t.unit(),
  Imported: __t.unit(),
});
export type ScriptSource = __Infer<typeof ScriptSource>;

// The tagged union or sum type for the algebraic type `SessionRole`.
export const SessionRole = __t.enum("SessionRole", {
  Owner: __t.unit(),
  Participant: __t.unit(),
  Observer: __t.unit(),
});
export type SessionRole = __Infer<typeof SessionRole>;

export const SiteId = __t.object("SiteId", {
  projectId: __t.string(),
});
export type SiteId = __Infer<typeof SiteId>;

export const SiteRight = __t.object("SiteRight", {
  id: __t.u64(),
  email: __t.string(),
  projectId: __t.string(),
  role: __t.string(),
  allowAuthoring: __t.bool(),
  updatedAt: __t.timestamp(),
});
export type SiteRight = __Infer<typeof SiteRight>;

export const User = __t.object("User", {
  userId: __t.string(),
  stdbIdentity: __t.string(),
  workosSub: __t.string(),
  email: __t.string(),
  displayName: __t.string(),
  get appRole() {
    return AppRole;
  },
  occupation: __t.string(),
  addedAt: __t.timestamp(),
  firstConnectedAt: __t.timestamp(),
  lastSeenAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type User = __Infer<typeof User>;

export const UserSite = __t.object("UserSite", {
  id: __t.u64(),
  userId: __t.string(),
  projectId: __t.string(),
  active: __t.bool(),
  joinedAt: __t.timestamp(),
  leftAt: __t.option(__t.timestamp()),
});
export type UserSite = __Infer<typeof UserSite>;

export const WaitSpec = __t.object("WaitSpec", {
  ms: __t.u32(),
});
export type WaitSpec = __Infer<typeof WaitSpec>;

export const WorkosOrgConfig = __t.object("WorkosOrgConfig", {
  id: __t.u32(),
  workosOrgId: __t.string(),
  configuredAt: __t.timestamp(),
});
export type WorkosOrgConfig = __Infer<typeof WorkosOrgConfig>;

